import { render, staticRenderFns } from "./Tiket.vue?vue&type=template&id=11a14199&"
import script from "./Tiket.vue?vue&type=script&lang=js&"
export * from "./Tiket.vue?vue&type=script&lang=js&"
import style0 from "./Tiket.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports